/**
 * Serviço para controle de acesso ao Assistente IA
 */

import { usuarioTemPermissaoIA } from "@/helpers/permissaoHelper";

/**
 * Verifica se o usuário tem acesso ao assistente IA
 * Baseado no sistema de permissões em vez de lista de clientes
 * @param {Object} store - Store do Vuex para verificar permissões
 * @returns {boolean} - True se tem acesso, false caso contrário
 */
export const clienteTemAcessoIA = (store) => {
  if (!store) return false;

  // Verifica se o usuário tem a permissão "vue-ia-visualizar"
  return usuarioTemPermissaoIA(store);
};

/**
 * Verifica se o assistente IA está ativo para o ambiente atual
 * @returns {boolean} - True se está ativo, false caso contrário
 */
export const assistenteIAAtivo = () => {
  // Verificar configurações globais ou feature flags
  return process.env.VUE_APP_IA_ENABLED !== "false";
};

/**
 * Obtém a configuração específica da IA para o cliente
 * @param {Object} cliente - Dados do cliente
 * @returns {Object} - Configurações da IA
 */
export const getConfigIA = (cliente) => {
  return {
    maxMessages: cliente.iaConfig?.maxMessages || 50,
    modelo: cliente.iaConfig?.modelo || "default",
    personalizacoes: cliente.iaConfig?.personalizacoes || {},
  };
};
